import './page/cbax-instock-amazon-config';

import deDE from "./snippet/de-DE";
import enGB from "./snippet/en-GB";

const { Module } = Shopware;

Module.register('cbax-instock-amazon', {
    type: 'plugin',
    name: 'instock-amazon',
    title: 'cbax-instock-amazon-config.general.title',
    description: 'cbax-instock-amazon-config.general.description',
    color: '#A092F0',
    icon: 'default-object-marketing',

    snippets: {
        'de-DE': deDE,
        'en-GB': enGB
    },

    routes: {
        config: {
            component: 'cbax-instock-amazon-config',
            path: 'config'
        },
    }
});
